<template>
    <maintenance-policy-page v-if="tabShortName === 'MaintenancePolicy'"></maintenance-policy-page>
    <ipm-standards-page v-else-if="tabShortName === 'IpmStandards'"></ipm-standards-page>
    <v-card v-else>
        <v-navigation-drawer
                right
                v-model="filter"
                fixed
                clipped
                width="500"
                app
                disable-resize-watcher
        >
            <sm-filter v-if="filter"></sm-filter>
        </v-navigation-drawer>

        <v-card flat id="scroll-target"
                class="sm-table-card"
        >
            <sm-tb-toolbar v-if="needActions"></sm-tb-toolbar>

            <sm-tb-dataTable :key="'table'+tabShortName+tableUpdater"></sm-tb-dataTable>
        </v-card>
        <v-divider></v-divider>
        <SmTbDataTablePaginator></SmTbDataTablePaginator>

        <sm-file-dialog
                ref="smFileDialog"
                :p-tab-name="tabShortName"
        ></sm-file-dialog>
        <sm-log-dialog
                v-if="tabShortName==='SysTableLog' && logDialog.dialog"
                :p-log-dialog.sync="logDialog.dialog"
                :p-log-object="logDialog.object"
        ></sm-log-dialog>
    </v-card>
</template>

<script>
	export default {
		name: 'sm-table-view',
		components: {
			MaintenancePolicyPage: () => import('@/views/MaintenancePolicyPage'),
			IpmStandardsPage: () => import('@/views/IpmStandardsPage'),
			smFileDialog: () => import( '@/components/TableView/FileDialog'),
			smLogDialog: () => import( '@/components/TableView/TableViewLogDialog'),
			smFilter: () => import('@/components/TableView/TableViewFilter'),
			SmTbToolbar: () => import('@/components/TableView/TableViewToolbar'),
			SmTbDataTable: () => import('@/components/TableView/TableViewDataTable'),
			SmTbDataTablePaginator: () => import('@/components/TableView/DataTablePaginator'),

		},
		data: () => ({
			logDialog: {dialog: false},
		}),

		computed: {
			tabShortName() {
				return this.$store.getters.getCurrentTableName
			},
			//следит за необхадимосью показывать кнопки действии в компаненте
			needActions() {
				return !(['SysTableLog'].includes(this.tabShortName))
			},
			filter: {
				get: function () {
					return this.$store.getters.getFilter
				},
				set: function (val) {
					return this.$store.dispatch('storeFilter', {filter: val})
				}
			},
			tableUpdater() {
				return this.$store.getters.getTableUpdater
			},
		},
		watch: {
			async '$route.params.tabName'(tabName, previousTabName) {
				if (tabName && tabName !== previousTabName) {
					await this.$store.dispatch('storeTabHeader', tabName);
				}
			},
			'$route.query.assetGroup'(assetGroup, previousAssetGroup) {
				if (this.tabShortName === 'Asset' && assetGroup !== previousAssetGroup) {
					this.$store.dispatch('refreshTableView');
				}
			},
		},
		async created() {
			await this.$store.dispatch('storeTabHeader', this.tabShortName);

		},
		mounted() {
			if (['MaintenancePolicy', 'IpmStandards'].includes(this.tabShortName)) return;
			(document.querySelector('.v-table__overflow') || {style: {}}).style.overflowX = 'hidden'
		}
	}
</script>
<style scoped>
    .sm-table-card {
        overflow-x: auto;
        height: calc(100vh - 120px);
        max-height: calc(100vh - 120px);
        overflow-y: auto;
        width: 100%;
    }
</style>
